// @ts-strict-ignore
'use client'

import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'
import React, { useEffect, useState } from 'react'

import QuestionIcon from '@/screens/CatalogSlug/page/assets/question.svg'
import { discountAdapter } from '@/screens/Discount/page/lib/discountSaleAdapter'
import { CatalogItemImagesSlider } from '@/screens/Discount/page/ui/CatalogItemImagesSlider/CatalogItemImagesSlider'
import { Tags } from '@/screens/Discount/page/ui/tags/tags'

import { sendYandexMetricaEvent } from '@/shared/integrations/yandex-metric/utils/send-metric-event'
import { BASE_URL } from '@/shared/lib/const/env'
import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { TDiscountProductItem } from '@/shared/types/deprecated-types'
import { Button, Modal, Popover } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

import { DynamicDiscountModal } from '../DiscountModal/DiscountModal'

import styles from './DiscountCatalogItem.module.scss'

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

// @ts-strict-ignore

type DiscountCatalogItemProps = {
	item: TDiscountProductItem
	showTip?: boolean
}

const CONDITION_POPUP = (
	<div className="discountFilterPopover">
		<b
			style={{
				color: `#3FAF65`,
				fontSize: `16px`,
				fontWeight: `500`,
				lineHeight: `22px`,
				marginBottom: `8px`,
				display: `inline-block`
			}}>
			Отличное
		</b>
		<p style={{ fontSize: `14px`, fontWeight: `400`, lineHeight: `20px`, letterSpacing: `0.28px` }}>
			Устройство имеет минимальные следы эксплуатации и визуально выглядит практически новым.
		</p>
		<br />
		<b
			style={{
				color: `#67BB49`,
				fontSize: `16px`,
				fontWeight: `500`,
				lineHeight: `22px`,
				marginBottom: `8px`,
				display: `inline-block`
			}}>
			Хорошее
		</b>
		<p style={{ fontSize: `14px`, fontWeight: `400`, lineHeight: `20px`, letterSpacing: `0.28px` }}>
			На устройстве присутствуют более значительные следы эксплуатации. Могут быть царапины и потертости на корпусе и
			дисплее
		</p>
		<br />
		<b
			style={{
				color: `#B7BA3A`,
				fontSize: `16px`,
				fontWeight: `500`,
				lineHeight: `22px`,
				marginBottom: `8px`,
				display: `inline-block`
			}}>
			Удовлетворительное
		</b>
		<p style={{ fontSize: `14px`, fontWeight: `400`, lineHeight: `20px`, letterSpacing: `0.28px` }}>
			На устройстве имеются значительные следы эксплуатации. Могут быть потертости, сколы, глубокие царапины на корпусе
			и дисплее
		</p>
	</div>
)

enum PropertiesNames {
	CONDITION = `Состояние`,
	ENGINEERS_COMMENT = `Описание`,
	SET = `Комплектация`,
	MARKDOWN_REASON = `Описание`,
	WARRANTY_EXPIRE = `Гарантия до`,
	STOCK_NAME = `В наличии`,
	BATTERY_SIZE = `Объём аккумулятора`
}

// Проверяем есть ли в урле дисканут код товара и есть есть
const getDiscountCodeFromUrl = (inputString: string, itemCode: string): boolean => {
	const pattern = /&ref_open_modal_(\d+)/

	const match = inputString.match(pattern)

	if (match) return inputString.match(pattern)[1] === itemCode

	return false
}

/**
 * Mini-card of discount catalog-old
 */
export const DiscountCatalogItem = ({ item, showTip }: DiscountCatalogItemProps): JSX.Element => {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const search = searchParams.toString()
	const asPath = `${pathname}${search ? `?${search}` : ''}`
	const discountModalButtonCls = `discount-modal-button-${item.DISCOUNT_KOD}`
	const modalIsOpened = getDiscountCodeFromUrl(asPath, item.DISCOUNT_KOD)
	const [isTagsPanelOpened, setIsTagsPanelOpened] = useState(false)
	const [isOpen, setIsOpen] = useState(false)

	// Открываем модалку конкретного товара если пользователь перешел по специальной ссылке
	useEffect(() => {
		const button = document.querySelector(`.${discountModalButtonCls}`)

		if (button && modalIsOpened) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			button.click()
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const onClick = () => {
		setIsOpen(true)
		sendYandexMetricaEvent(`init_a_discount_request`)
	}

	const onClose = () => {
		setIsOpen(false)

		if (typeof window === 'undefined') return

		const url = new URL(window.location.href)
		url.searchParams.delete('ref_open_modal')
		window.history.replaceState({}, '', url.toString())
	}

	const labels = discountAdapter(item)
	return (
		<div className={styles.item}>
			<div className={styles.tags}>
				<Tags
					tags={labels}
					type={`regular`}
					isOpen={isTagsPanelOpened}
					onToggle={() => setIsTagsPanelOpened(prev => !prev)}
				/>
			</div>
			{/* Image */}
			<div className={styles.image}>
				<CatalogItemImagesSlider
					mainSrc={BASE_URL + item.IMAGES[0]}
					restSrces={item.IMAGES}
					isHovered={false}
					title={item.NAME}
				/>
			</div>
			{/* Title */}
			<p className={styles.titleMobile}>{item.TITLE}</p>
			{/* Product properties */}
			<dl className={styles.props}>
				<p className={styles.title}>{item.TITLE}</p>
				{!!item.CONDITION && (
					<span>
						<dt>
							{PropertiesNames.CONDITION}
							{showTip && (
								<Popover content={CONDITION_POPUP} placement="bottomRight">
									<Icon icon={QuestionIcon} width={16} height={16} />
								</Popover>
							)}
							:
						</dt>
						<dd>{item.CONDITION}</dd>
					</span>
				)}

				{!!item.BUNDLE && (
					<span>
						<dt>{PropertiesNames.SET}:</dt>
						<dd>{item.BUNDLE}</dd>
					</span>
				)}

				{!!item.BATTERY_SIZE && (
					<span>
						<dt>{PropertiesNames.BATTERY_SIZE}:</dt>
						<dd>{item.BATTERY_SIZE}%</dd>
					</span>
				)}

				{!!item.ENGINEERS_COMMENT && (
					<span>
						<dt>{PropertiesNames.MARKDOWN_REASON}:</dt>
						<dd>{item.ENGINEERS_COMMENT}</dd>
					</span>
				)}

				{!!item.WARRANTY_EXPIRE && (
					<span>
						<dt>{PropertiesNames.WARRANTY_EXPIRE}:</dt>
						<dd>{item.WARRANTY_EXPIRE}</dd>
					</span>
				)}

				{!!item.STOCK_NAME && (
					<span>
						<dt>{PropertiesNames.STOCK_NAME}:</dt>
						<Link prefetch={false} href={`/shops/` + item.STOCK_ID} target="_blank">
							<dd>
								{!!item.IS_SERVICE && `Сервисный центр `}
								{item.STOCK_NAME}
							</dd>
						</Link>
					</span>
				)}
			</dl>
			{/* Price */}
			<div className={styles.priceBlock}>
				<span className={styles.price}>
					{formatPrice(+item.PRICE)}
					{item.OLD_PRICE && item.OLD_PRICE > item.PRICE && <span>{formatPrice(+item.OLD_PRICE)}</span>}
				</span>

				<div>
					<Button id={`gtm-discount-init-${item.DISCOUNT_KOD}`} className={discountModalButtonCls} onClick={onClick}>
						Оставить заявку
					</Button>
					<Modal isOpen={isOpen} onClose={onClose} className={styles.modal} contentClassName={styles.modalContent}>
						<DynamicDiscountModal {...item} submitId={`gtm-discount-request`} onOk={onClose} onCancel={onClose} />
					</Modal>
				</div>
			</div>
		</div>
	)
}
